/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Optin_PendingInputs */



/**
* | output |
* | --- |
* | "Saved. Your confirmation email will follow shortly." |
*
* @param {Newsletter_Optin_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const newsletter_optin_pending = /** @type {((inputs?: Newsletter_Optin_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Optin_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gespeichert. Die Bestätigungs-E-Mail folgt in Kürze.")
	return /** @type {LocalizedString} */ ("Saved. Your confirmation email will follow shortly.")
});